/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useHeaderData } from '@/features/header/api/getHeader';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';

const LazyAltYMMEContentBlock = dynamic(
  () => import('@/features/ymme/components/AltYMMEContentBlock').then((mod) => mod.default),
  { ssr: true },
);

type Props = {
  removeMargins?: boolean;
  nonShopPage?: boolean;
  pageType?: string;
  onHeightChange?: (height: string) => void;
};

export function CMSYmme({ removeMargins, pageType, onHeightChange, nonShopPage = false }: Props) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const { data: headerData } = useHeaderData();
  const router = useLegacyRouter();

  // Check if we're on the search result page
  const isSearchResultPage = router.pathname === '/searchresult';

  // On the search page YMME must always show (AC #6: force YMME when product finder data exists).
  // For other search-page renders from non-CMS paths, keep the legacy mobile+vehicle suppression.
  const shouldRenderComponent =
    isMobile &&
    !!headerData?.vehicleMap?.vehicleName &&
    isSearchResultPage &&
    pageType !== 'search';

  useEffect(() => {
    if (onHeightChange) {
      onHeightChange(isMobile ? '100%' : '115px');
    }
  }, [isMobile, onHeightChange]);

  return (
    <>
      {!shouldRenderComponent && (
        <>
          <LazyAltYMMEContentBlock
            nonShopPage={nonShopPage}
            pageType={pageType}
            removeMargins={removeMargins}
          />
        </>
      )}
    </>
  );
}
